import type { PluginObject } from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import { isEmpty } from 'lodash';
import { desensitize, showPlatform } from '@/util';
// v-encrypt: 加密

const encrypt = {
  bind(el: HTMLElement, binding, vnode, oldVnode) {
    const reg = /<[^>]*>/;
    const data = `${cloneDeep(el.innerHTML)}<i class="el-icon-view text-blue-15 r-ml-4"/>`;
    // 1正常 2半脱敏 3全脱敏
    //     正常：所有风险字段，无论在列表中，还是在详情中，均明文展示，也可导出下载（导出时有履历记录）；
    // 半脱敏：风险字段在列表中脱敏展示，但在详情中予以正常显示，导出至文件时，也采用脱敏方式；
    // 	全脱敏：风险字段在列表、详情及导出时，均以脱敏方式展示。

    const secureLevel = +localStorage.getItem('secureLevel');
    // 如果是secureLevel全脱敏。则level为1（详情）也要脱敏
    const level = binding.value.level || 0

    const showReally = showPlatform()
    if ((secureLevel === 2 || secureLevel === 3) && (!isEmpty(binding.value.data))) {

      if (secureLevel === 2 && level) {
        el.innerHTML = binding.value.data;
      }else{
        let num = 0
        const textContent = desensitize(binding.value.data, binding.value.type) || '';
        const transData = showReally ? `${el.innerHTML.replace(binding.value.data, textContent)}<i class="el-icon-view text-blue-15 r-ml-4"/>` : el.innerHTML.replace(binding.value.data, textContent);
        el.innerHTML = transData;
        el.addEventListener('click', () => {
          num++
          if (num % 2 === 0) {
            el.innerHTML = el.innerHTML.replace(binding.value.data, textContent);
          } else {
            el.innerHTML = data;
          }
        });
      }


    } else {
      el.innerHTML = binding.value.data;
    }
  },
};

const encryptInstall: PluginObject<any> = {
  install: (vue, options?) => {
    vue.directive('encrypt', encrypt);
  },
};

export default encryptInstall;

